<template>
  <div id="app">
    <transition>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  created() {
    if (!this.$store.getters.pages.loaded) {
      this.$store
        .dispatch('refreshContent', {
          menus: [this.header],
        })
        .catch(err => {
          console.warn('err')
        })
    }
  },
}
</script>

<style lang="scss">
@import './assets/scss/main.scss';

body {
  @include cursor();
  &.scroll-lock {
    overflow: hidden;
    height: 100vh;
  }

  a,
  .swiper-button-next,
  .swiper-button-prev,
  .swiper-scrollbar-drag,
  .project-description,
  .show-more {
    @include cursor();
  }
}

.hidden {
  display: none;
}
.page {
  &:before {
    content: '';
    display: block;
    height: $nav-height;
    min-height: $nav-min-height;
  }
}
.content-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 96;
  background-color: $base-overlay;
  transition: 0.3s;
  opacity: 0;
  visibility: hidden;

  &.active {
    opacity: 1;
    visibility: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue